import src from "IMAGE";
export default { src, width: 480, height: 480, blurWidth: 0, blurHeight: 0};
